(function(){
document.querySelectorAll('.rg[data-rg]').forEach(function(root){
  var cfg = root.dataset;
  var form = root.querySelector('#rg-form');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Announcement rotation */
  (function(){
    var items = root.querySelectorAll('[data-rg-bar] span'); if (items.length < 2 || reduce) return;
    var i = 0; setInterval(function(){ items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); }, 4000);
  })();

  /* Gallery */
  var main = root.querySelector('[data-rg-main]');
  root.querySelectorAll('.rg-thumbs button').forEach(function(b){
    b.addEventListener('click', function(){
      if (main){ main.src = b.dataset.src; main.alt = b.dataset.alt; }
      root.querySelectorAll('.rg-thumbs button').forEach(function(x){ x.removeAttribute('aria-current'); });
      b.setAttribute('aria-current','true');
    });
  });

  /* Bundles */
  var idInput = root.querySelector('#rg-variant-id');
  var cmp = root.querySelector('[data-rg-compare]'), save = root.querySelector('[data-rg-save]');
  root.querySelectorAll('input[name="rg-bundle"]').forEach(function(r){
    r.addEventListener('change', function(){
      if (!r.checked) return;
      idInput.value = r.value;
      root.querySelectorAll('[data-rg-price]').forEach(function(el){ el.textContent = r.dataset.price; });
      root.querySelectorAll('[data-rg-label]').forEach(function(el){ el.textContent = r.dataset.label; });
      if (cmp){ cmp.textContent = r.dataset.compare; cmp.hidden = !r.dataset.compare; }
      if (save){ save.textContent = 'SAVE ' + r.dataset.save + '%'; save.hidden = r.dataset.save === '0'; }
    });
  });
  root.querySelectorAll('[data-rg-submit]').forEach(function(b){
    b.addEventListener('click', function(){ if (form.requestSubmit) form.requestSubmit(root.querySelector('#rg-atc')); else form.submit(); });
  });

  /* Delivery estimate */
  (function(){
    var proc = +cfg.proc || 1, tmin = +cfg.tmin || 3, tmax = +cfg.tmax || 5;
    function add(d, n){ d = new Date(d); while (n > 0){ d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
    var f = function(d){ return d.toLocaleDateString('en-US', { weekday:'short', month:'short', day:'numeric' }); };
    var el = root.querySelector('#rg-eta'); if (el){ var n = new Date(); el.textContent = f(add(n, proc + tmin)) + ' – ' + f(add(n, proc + tmax)); }
  })();

  /* Compatibility checker
     data: make -> model -> [[engine, firstYear, lastYear, isDfmTruck]]
     Rules (edit to match your supplier):
       - 2019+ DFM trucks with the 10-speed, or "Not sure", get "email us your VIN to confirm"
       - 2022 refreshed Silverado/Sierra get "email us to confirm" */
  (function(){
    var data = {
      'Chevrolet': {
        'Avalanche': [['5.3L V8',2007,2013],['6.0L V8',2007,2009]],
        'Camaro': [['3.6L V6',2016,2024],['6.2L V8',2010,2024]],
        'Caprice PPV': [['6.0L V8',2011,2017]],
        'Colorado': [['3.6L V6',2015,2020]],
        'Corvette': [['6.2L V8',2012,2019]],
        'Equinox Sport': [['3.6L V6',2008,2009]],
        'Express 1500': [['5.3L V8',2014,2014]],
        'Impala': [['3.9L V6',2007,2009],['5.3L V8',2006,2009]],
        'Malibu': [['3.6L V6',2008,2012],['3.9L V6',2006,2007]],
        'Monte Carlo': [['5.3L V8',2006,2007]],
        'SS': [['6.2L V8',2014,2017]],
        'Silverado 1500': [['4.3L V6',2007,2021],['5.3L V8',2007,2018],['5.3L V8',2019,2022,1],['6.0L V8',2007,2013],['6.2L V8',2009,2018],['6.2L V8',2019,2022,1]],
        'Silverado 1500 LD': [['5.3L V8',2019,2019]],
        'Suburban': [['5.3L V8',2014,2020],['6.0L V8',2016,2018],['6.2L V8',2019,2020]],
        'Suburban 1500': [['5.3L V8',2007,2014],['6.0L V8',2007,2013]],
        'Suburban 2500': [['6.0L V8',2007,2013]],
        'Tahoe': [['5.3L V8',2007,2020],['6.2L V8',2018,2020]],
        'Trailblazer': [['5.3L V8',2006,2008]],
        'Uplander': [['3.9L V6',2006,2009]]
      },
      'GMC': {
        'Acadia': [['3.6L V6',2007,2008]],
        'Canyon': [['3.6L V6',2015,2020]],
        'Envoy': [['5.3L V8',2005,2009]],
        'Sierra / Denali': [['6.2L V8',2009,2018]],
        'Sierra 1500': [['4.3L V6',2007,2018],['5.3L V8',2007,2018],['5.3L V8',2019,2022,1],['6.0L V8',2007,2013],['6.2L V8',2007,2018],['6.2L V8',2019,2022,1]],
        'Yukon': [['5.3L V8',2007,2020],['6.2L V8',2010,2020]],
        'Yukon XL': [['5.3L V8',2015,2020]],
        'Yukon XL 1500': [['6.2L V8',2014,2014]]
      },
      'Cadillac': {
        'ATS': [['3.6L V6',2013,2019]],
        'CT6': [['3.6L V6',2016,2018]],
        'CT6 (non Hybrid)': [['3.0L V6',2016,2018]],
        'CTS': [['3.6L V6',2004,2019],['6.0L V8',2006,2007],['6.2L V8',2009,2019]],
        'Escalade / ESV': [['6.0/6.2L V8',2010,2020]],
        'Escalade ESV': [['6.2L V8',2010,2013]],
        'SRX': [['3.6L V6',2004,2009]],
        'STS': [['3.6L V6',2005,2007]],
        'XT5': [['3.6L V6',2017,2019]],
        'XTS': [['3.6L V6',2013,2019]]
      },
      'Buick': {
        'Enclave': [['3.6L V6',2008,2020]],
        'Envision': [['2.5L L4',2017,2018]],
        'LaCrosse': [['3.6L V6',2005,2019],['5.3L V8',2008,2009]],
        'Rainier': [['5.3L V8',2005,2007]],
        'Rendezvous': [['3.5/3.6L V6',2006,2007]],
        'Terraza': [['3.9L V6',2006,2007]]
      },
      'Pontiac': {
        'G6': [['3.6L V6',2008,2009],['3.9L V6',2007,2007]],
        'G8': [['3.6L V6',2008,2009],['6.0L V8',2008,2009],['6.2L V8',2009,2009]],
        'Grand Prix': [['3.8L V6',2007,2007],['5.3L V8',2005,2008]],
        'Montana': [['3.9L V6',2006,2009]],
        'Torrent': [['3.6L V6',2008,2009]]
      },
      'Holden': {
        '9C1 Police Special': [['6.0L V8',2015,2018]],
        'Colorado': [['3.6L V6',2006,2009]],
        'Commodore Wagon': [['3.6L V6',2006,2018]],
        'Crewman / UTE': [['3.6L V6',2006,2018]],
        'Rodeo': [['3.6L V6',2006,2011]],
        'VE Commodore Omega': [['3.6L V6',2006,2009]],
        'VZ Calais SV6': [['3.6L V6',2006,2018]],
        'VZ Commodore Sedan': [['3.6L V6',2006,2018]],
        'WL Statesman': [['3.6L V6',2006,2017]],
        'WM Statesman / Caprice': [['3.6L V6',2006,2017]]
      },
      'Saab': {
        '9-7X': [['5.3L V8',2005,2009]]
      },
      'Saturn': {
        'Aura XR': [['3.6L V6',2007,2009]],
        'Outlook XE': [['3.6L V6',2007,2008]],
        'Relay': [['3.9L V6',2006,2008]],
        'VUE XR / Red Line': [['3.9L V6',2008,2009]]
      },
      'Isuzu': {
        'Ascender': [['5.3L V8',2005,2009]]
      },
      'Suzuki': {
        'XL7': [['3.6L V6',2007,2009]]
      }
    };
    var f = root.querySelector('[data-rg-fit]'); if (!f) return;
    var q = function(n){ return f.querySelector('[data-f="' + n + '"]'); };
    var mk = q('make'), md = q('model'), yr = q('year'), en = q('engine'), tr = q('trans'), y22 = q('y22');
    var box = function(n){ return f.querySelector('[data-x="' + n + '"]'); };
    var out = root.querySelector('[data-rg-fit-result]');
    var mail = cfg.email || '';
    var link = '<a href="mailto:' + mail + '">' + mail + '</a>';
    function opts(sel, list, ph){ sel.innerHTML = '<option value="">' + ph + '</option>' + list.map(function(v){ return '<option>' + v + '</option>'; }).join(''); }
    function hideExtra(){ ['engine','trans','y22'].forEach(function(n){ box(n).hidden = true; }); en.value = tr.value = y22.value = ''; }
    function reset(){ out.className = 'rg-fit-result'; }
    function rows(){ if (!mk.value || !md.value || !yr.value) return []; var y = +yr.value; return data[mk.value][md.value].filter(function(r){ return y >= r[1] && y <= r[2]; }); }
    function isDfm(){ var r = rows().filter(function(r){ return r[0] === en.value; })[0]; return r && r[3]; }
    function refreshExtras(){
      var rs = rows(), engines = rs.map(function(r){ return r[0]; }).filter(function(v,i,a){ return a.indexOf(v) === i; });
      box('engine').hidden = engines.length < 1;
      if (engines.length){ var keep = en.value; opts(en, engines, 'Select engine'); if (engines.indexOf(keep) > -1) en.value = keep; else if (engines.length === 1) en.value = engines[0]; }
      var dfm = isDfm();
      box('trans').hidden = !dfm; if (!dfm) tr.value = '';
      var ask22 = dfm && +yr.value === 2022 && /Silverado|Sierra/.test(md.value);
      box('y22').hidden = !ask22; if (!ask22) y22.value = '';
    }
    opts(mk, Object.keys(data), 'Select make');
    mk.addEventListener('change', function(){
      reset(); hideExtra();
      if (!mk.value){ md.disabled = yr.disabled = true; opts(md, [], 'Select model'); opts(yr, [], 'Select year'); return; }
      opts(md, Object.keys(data[mk.value]).sort(), 'Select model'); md.disabled = false; opts(yr, [], 'Select year'); yr.disabled = true;
    });
    md.addEventListener('change', function(){
      reset(); hideExtra();
      if (!md.value){ yr.disabled = true; return; }
      var ys = []; for (var y = 2026; y >= 2004; y--) ys.push(y); opts(yr, ys, 'Select year'); yr.disabled = false;
    });
    yr.addEventListener('change', function(){ reset(); hideExtra(); refreshExtras(); });
    en.addEventListener('change', function(){ reset(); refreshExtras(); });
    function ready(){ return mk.value && md.value && yr.value && (box('engine').hidden || en.value) && (box('trans').hidden || tr.value) && (box('y22').hidden || y22.value); }
    [yr, en, tr, y22].forEach(function(el){ el.addEventListener('change', function(){ if (ready() || (yr.value && !rows().length)) run(); else reset(); }); });
    function show(k, t, b){
      out.className = 'rg-fit-result is-show is-' + k;
      var cta = '';
      if (k === 'yes') cta = form ? '<button type="button" class="rg-fit-cta" data-rg-fit-buy>Add to cart</button>' : (cfg.productUrl ? '<a class="rg-fit-cta" href="' + cfg.productUrl + '">' + (cfg.cta || 'Shop now') + '</a>' : '');
      out.innerHTML = '<strong>' + t + '</strong>' + b + cta;
      var buy = out.querySelector('[data-rg-fit-buy]'); if (buy) buy.addEventListener('click', function(){ if (form.requestSubmit) form.requestSubmit(root.querySelector('#rg-atc')); else form.submit(); });
      var r = out.getBoundingClientRect(); if (r.bottom > window.innerHeight - 80 || r.top < 0) out.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }
    f.addEventListener('submit', run);
    function run(){
      if (!mk.value || !md.value || !yr.value){ show('check', 'Pick a make, model and year', 'All three are needed to check compatibility.'); return; }
      var name = yr.value + ' ' + mk.value + ' ' + md.value;
      if (!rows().length){ show('no', 'Not on our list for the ' + name, 'Email ' + link + ' and we\'ll double-check for you.'); return; }
      if (!box('engine').hidden && !en.value){ show('check', 'Which engine do you have?', 'Pick your engine above. It\'s badged on the fender or tailgate.'); return; }
      if (!box('trans').hidden && !tr.value){ show('check', 'Which transmission do you have?', 'Pick your transmission above to finish the check.'); return; }
      if (!box('y22').hidden && !y22.value){ show('check', 'Which 2022 model do you have?', 'Pick carry-over or refreshed above.'); return; }
      if (y22.value === 'refresh' || y22.value === 'unsure'){ show('check', 'Let\'s confirm your ' + name, 'Refreshed 2022 trucks need a quick check. Email ' + link + ' with your VIN and we\'ll confirm before you order.'); return; }
      if (tr.value === '10-speed automatic' || tr.value === 'Not sure'){ show('check', 'Likely fits your ' + name, 'Some 2019+ trucks with the 10-speed need a quick check. Email ' + link + ' with your VIN and we\'ll confirm before you order.'); return; }
      show('yes', '✓ ' + brandName + ' fits your ' + name, 'Works with the ' + en.value + '. You\'re covered by our ' + cfg.gdays + '-day money-back guarantee either way.');
    }
    var brandName = cfg.brand;
  })();

  /* Sticky add to cart (mobile) */
  (function(){
    var bar = root.querySelector('[data-rg-sticky]'), atc = root.querySelector('#rg-atc'); if (!bar || !atc) return;
    var shown = null, ticking = false;
    function check(){ ticking = false; var past = atc.getBoundingClientRect().bottom < 0; if (past === shown) return; shown = past;
      bar.classList.toggle('is-show', past); bar.setAttribute('aria-hidden', past ? 'false' : 'true'); bar.querySelector('button').tabIndex = past ? 0 : -1; }
    window.addEventListener('scroll', function(){ if (!ticking){ ticking = true; requestAnimationFrame(check); } }, { passive: true });
    check();
  })();
});
})();